import Renderer from "@wielink/datatables/Renderers/Renderer";

class ActionsRenderer extends Renderer {
	render() {
		if (this.row.is_concept) {
			return '';
		}

		let editUrl = this.config.editUrl;
		for(let key in this.row) {
			editUrl = editUrl.replace(`_${key}_`, this.row[key]);
		}

		return `
			<div class="d-inline-flex gap-2">
				<a target="_blank" href="${editUrl}" class="btn btn-sm btn-dark" style="font-size: 1.4rem; padding: 3px !important;" aria-label="Toon PDF" title="Toon PDF">
					<i class="bi bi-filetype-pdf"></i>
				</a>
			</div>
		`
	}
}

export default ActionsRenderer;